import usePublicSettings from '../../hooks/usePublicSettings.js';

export default function TopBar() {
  const { settings } = usePublicSettings();
  const phone = settings?.sitePhone?.trim();
  const hours = settings?.siteBusinessHours?.trim();

  // Right side shows the contact phone (+ hours) from settings when available;
  // otherwise the generic reseller line keeps the bar from looking empty.
  const right = phone
    ? `Call: ${phone}${hours ? ` · ${hours}` : ''}`
    : 'Authorized resellers';

  return (
    <div className="bg-brand-700 py-2 text-xs text-white">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-x-4 gap-y-1 px-4">
        <span className="truncate">Free delivery across Canada · Authorized resellers</span>
        <span className="hidden md:block">{right}</span>
      </div>
    </div>
  );
}
